import React, { useState, useEffect } from "react";
import styles from "./AdminDashboard.module.css";
import { useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { apiService } from "../../services/api";
import { User } from "../../types";

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [user, setUser] = useState<User | null>(null);

  useEffect(() => {
    const userData = localStorage.getItem("user");
    if (userData) {
      setUser(JSON.parse(userData));
    } else {
      navigate("/admin/login");
    }
  }, [navigate]);

  const { data: shops, isLoading: shopsLoading } = useQuery({
    queryKey: ["shops"],
    queryFn: () => apiService.getShops(),
  });

  const { data: categories, isLoading: categoriesLoading } = useQuery({
    queryKey: ["categories"],
    queryFn: () => apiService.getCategories(),
  });

  const { data: events, isLoading: eventsLoading } = useQuery({
    queryKey: ["events"],
    queryFn: () => apiService.getEvents(),
  });

  const handleLogout = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    navigate("/admin/login");
  };

  if (shopsLoading || categoriesLoading || eventsLoading) {
    return (
      <div className={styles.dashboardContainer}>
        <div className={styles.loadingSpinner}>
          Загрузка панели управления...
        </div>
      </div>
    );
  }

  return (
    <div className={styles.dashboardContainer}>
      <header className={styles.header}>
        <div className={styles.logo}>Панель управления торговым центром</div>
        <div className={styles.userInfo}>
          <span className={styles.userEmail}>{user?.email}</span>
          <button className={styles.logoutButton} onClick={handleLogout}>
            Выйти
          </button>
        </div>
      </header>

      <main className={styles.mainContent}>
        {/* <div className={styles.welcomeCard}>
          <h1 className={styles.welcomeTitle}>
            Добро пожаловать в панель управления
          </h1>
          <p className={styles.welcomeSubtitle}>
            Управляйте системой навигации торгового центра
          </p>
        </div> */}

        {/* <div className={styles.statsGrid}>
          <div className={styles.statCard}>
            <div className={styles.statNumber}>{shops?.length || 0}</div>
            <div className={styles.statLabel}>Объекты</div>
          </div>
          <div className={styles.statCard}>
            <div className={styles.statNumber}>{categories?.length || 0}</div>
            <div className={styles.statLabel}>Категории</div>
          </div>
          <div className={styles.statCard}>
            <div className={styles.statNumber}>{events?.length || 0}</div>
            <div className={styles.statLabel}>События</div>
          </div>
        </div> */}

        <div className={styles.quickActions}>
          <h2 className={styles.quickActionsTitle}>Быстрые действия</h2>
          <div className={styles.actionGrid}>
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/shops")}
            >
              Управление объектами
            </button>
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/tabs")}
            >
              Управление вкладками
            </button>
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/categories")}
            >
              Управление категориями
            </button>
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/events")}
            >
              Управление событиями
            </button>
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/slider")}
            >
              Управление слайдером
            </button>
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/marquee")}
            >
              Управление бегущей строкой
            </button>
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/screensaver")}
            >
              Управление скринсейвером
            </button>
            {/* <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/floors")}
            >
              Управление картой
            </button>
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/terminals")}
            >
              Управление стендами
            </button>
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/routes")}
            >
              Управление маршрутами
            </button> */}
            <button
              className={styles.actionButton}
              onClick={() => navigate("/admin/working-hours")}
            >
              Управление временем работы
            </button>
          </div>
        </div>
      </main>
    </div>
  );
}
